var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLastAccessBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "220px",
    height: "385px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontSize: 500,
    y: 360,
    fontFamily: "Times New Roman"
  }, "?")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLastAccessBackground);
export default __webpack_public_path__ + "static/media/no-last-access-background.f823bf0b6049aeb696157759994ac55a.svg";
export { ForwardRef as ReactComponent };